const TableCell = (props: any) => {
  let cssClass = props.class ?? "";
  let label = props.label ?? "";
  return (
    <td className={cssClass}>
      <span>{label}</span>
    </td>
  );
};

export default TableCell;
